// -------------------------------------------------------------------------- */
// ------------------------- TO FIXED LOCALE STRING ------------------------- */

import Utils from '../mixins/UtilsMixin';

/**
 * Thousands separator based on users locale.
 * Please note that it is assigned by self-invoking function
 */
const decimalSeparator = (1.1).toLocaleString().substring(1, 2);
const thousandsSeparator = decimalSeparator === '.' ? ',' : '.';

/**
 * Adds thousands separator as comma
 * See https://stackoverflow.com/a/2901298/3062961
 */
const withThousandsSeparator = x => {

    if (x === null) {
        return '/';
    }

    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
};

const toFixedLocaleString = val => {
    if (typeof val === 'number') {
        let res;
        res =  Utils.methods.roundTo(val, 2);
        return withThousandsSeparator(res);
    }

    return val;
};

// -------------------------------------------------------------------------- */
// -------------------------- CAPITALIZING STRINGs -------------------------- */

/**
 * First character in a string to uppercase
 * 'first second third' => 'First second third'
 *
 * @param string val
 * @return string
 */
const capitalize = val => {
    if (typeof val !== 'string') {
        return '';
    }

    return val.charAt(0).toUpperCase() + val.slice(1);
};

/**
 * Uppercase each word in a string
 * 'first second third' => 'First Second Third'
 *
 * @param string val
 * @return string
 */
const uppercaseWords = val => {
    if (typeof val !== 'string') {
        return '';
    }

    return val.split(' ').map(w => capitalize(w)).join(' ');
};

export default {
    withThousandsSeparator,
    toFixedLocaleString,
    capitalize,
    uppercaseWords,
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/strings.js